import { useEffect } from "react";
import { SITE } from "./site";

type SeoProps = { title: string; description: string; path?: string };

const upsert = (selector: string, attr: "name" | "property", key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${selector}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(selector, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, path = "/" }: SeoProps) => {
  useEffect(() => {
    document.title = title;
    const url = SITE.url + path;
    upsert("name", "name", "description", description);
    upsert("property", "property", "og:title", title);
    upsert("property", "property", "og:description", description);
    upsert("property", "property", "og:url", url);
    upsert("name", "name", "twitter:title", title);
    upsert("name", "name", "twitter:description", description);

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = url;
  }, [title, description, path]);

  return null;
};
